export default "__VITE_ASSET__vcJrsFkJ__"